import React from 'react';
import PropTypes from 'prop-types';
import Color from 'color';
import { focusRings } from 'v5/design-system/_common/focusRing.js';
import { cn } from 'v5/platform/dom/cn';

const CalendarPen = ({ label, colour, onClick, isActive }) => (
  <button
    onClick={onClick}
    aria-pressed={isActive}
    className={cn([
      'flex items-center bg-white border-none rounded p-1.5 transition-colors duration-200',
      'hover:bg-eggplant hover:text-white',
      { 'bg-eggplant text-white': isActive },
      'clickable',
      focusRings.focus.visible
    ])}
  >
    <span
      className={cn(['inline-block w-5.5 h-4 mr-1 rounded-sm shrink-0'])}
      style={{
        backgroundColor: colour,
        // Take the hue from the color and make the border really dark or really light
        border: `1px solid ${Color(colour)
          .hsl()
          .lightness(Color(colour).isDark() ? 100 : 20)
          .alpha(0.5)
          .string()}`
      }}
    />
    <span className="text-13-600">{label}</span>
  </button>
);

CalendarPen.propTypes = {
  label: PropTypes.string.isRequired,
  colour: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool
};

export default CalendarPen;
